import { gql } from '@apollo/client'

export const TASKS_LIST = gql`
    query TasksList(
        $subtype: String!
        $containerGuid: String!
        $offset: Int!
        $limit: Int!
    ) {
        entities(
            subtype: $subtype
            containerGuid: $containerGuid
            offset: $offset
            limit: $limit
        ) {
            total
            edges {
                guid
                ... on Task {
                    guid
                    localTitle
                    title
                    state
                    localRichDescription
                    richDescription
                    canEdit
                    isTranslationEnabled
                }
            }
        }
    }
`
